export const parseAsNumber = (value: string | number): number => {
  return typeof value === 'string' ?
    Number.parseInt(value) :
    value;
};
